import styled from "styled-components";

import { token } from "../../components/FormKit/styled";

export const LeftButtonSection = styled.div``;

export const TableWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;

export const NoteWrapper = styled.div`
  padding: 0 20px;
`;

export const DataNote = styled.p`
  display: flex;
  align-items: flex-start;
  gap: ${token.space.sm};
  margin: 0 0 ${token.space.md};
  font-size: 12px;
  line-height: 1.5;
  color: ${token.color.textMuted};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 65px;
`;
